import { render } from "./IconNdlOnline.vue?vue&type=template&id=3f87526a&scoped=true&ts=true"
import script from "./IconNdlOnline.vue?vue&type=script&lang=ts"
export * from "./IconNdlOnline.vue?vue&type=script&lang=ts"

import "./IconNdlOnline.vue?vue&type=style&index=0&id=3f87526a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f87526a"]])

export default __exports__